import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export default function Navbar({backButton=true, rightButtonIcon, rightButtonOnClick, title}) {
    const navigate = useNavigate();

    const outerBoxStyles = {
        // backgroundColor: 'yellow',
        display: 'flex',
        flexDirection: 'row',
        marginTop: '10px',
    }

    const iconContainerStyles = {
        marginLeft: '5px',
        minWidth: '40px', // to keep spacing consistent even when no icon is present
    }

    const textContainerStyles = {
        // backgroundColor: 'green',
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        marginY: 'auto',
    }

    const rightButtonContainerStyles = {
        // backgroundColor: 'red'
        marginRight: '5px',
        minWidth: '40px', // to keep spacing consistent even when no icon is present
    }

    return (
        <Box sx={outerBoxStyles}>
            <Box sx={iconContainerStyles}>
                {backButton &&
                    <IconButton color='black' onClick={() => {navigate(-1)}}>
                        <ArrowBackIcon/>
                    </IconButton>
                }
            </Box>
            <Box sx={textContainerStyles}>
                <Typography variant='body1' fontSize={'14px'} fontWeight={'Medium'}>{title}</Typography>
            </Box>
            <Box sx={rightButtonContainerStyles}>
                {rightButtonIcon &&
                    <IconButton onClick={rightButtonOnClick}>
                        {rightButtonIcon}
                    </IconButton>
                }
            </Box>
        </Box>
    )
}